import React from 'react';
import { Box, Typography } from '@mui/material';
import { ConnectionStatus } from '../../types';
import { formatLastUpdate } from '../../utils/connectionUtils';

interface TooltipContentProps {
  statusLabel: string;
  lastDataUpdate?: Date | null;
  displayStatus: ConnectionStatus;
}

const TooltipContent: React.FC<TooltipContentProps> = ({
  statusLabel,
  lastDataUpdate,
  displayStatus,
}) => {
  return (
    <Box sx={{ maxWidth: 400 }}>
      <Typography
        variant='caption'
        display='block'
        fontWeight='bold'
        gutterBottom
      >
        Status: {statusLabel}
      </Typography>
      <Typography variant='caption' display='block'>
        Last Update: {formatLastUpdate(lastDataUpdate)}
      </Typography>

      {displayStatus === 'connected' && <ConnectedStatus />}

      {displayStatus === 'disconnected' && (
        <Typography
          variant='caption'
          display='block'
          color='error.light'
          sx={{ mt: 1 }}
        >
          ✗ Connection lost - showing cached data only
        </Typography>
      )}

      {displayStatus === 'reconnecting' && (
        <Typography
          variant='caption'
          display='block'
          color='warning.light'
          sx={{ mt: 1 }}
        >
          ⟳ Reconnecting...
        </Typography>
      )}
    </Box>
  );
};

const ConnectedStatus: React.FC = () => {
  return (
    <>
      <Typography
        variant='caption'
        display='block'
        color='success.light'
        sx={{ mt: 1 }}
      >
        ✓ Receiving real-time updates
      </Typography>
      <Typography
        variant='caption'
        display='block'
        sx={{ mt: 1, fontStyle: 'italic' }}
      >
        Monitoring active alerts
      </Typography>
    </>
  );
};

export default TooltipContent;
